import { BracketTypeList, CANVAS_SIZE_MAX, CANVAS_SIZE_MIN, CANVAS_ZOOM_MAX, CANVAS_ZOOM_MIN, CanvasTypeList, ColumnTypeList, DatabaseList, LanguageList, NameCaseList, NameViewModeList } from "../constants/schema.js";
import { DatabaseVendorList } from "../constants/sql/database.js";
import { arrayHas } from "./arrayHas.js";
import { clamp, isString } from "es-toolkit";
import { round } from "es-toolkit/compat";
//#region src/utils/validation.ts
var NOT_NUM = /[^0-9]/g;
var toNumString = (value) => value.replace(NOT_NUM, "");
var canvasInRange = (value) => clamp(value, CANVAS_SIZE_MIN, CANVAS_SIZE_MAX);
var zoomInRange = (value) => clamp(value, CANVAS_ZOOM_MIN, CANVAS_ZOOM_MAX);
var maxWidthCommentInRange = (value) => clamp(value, 60, 200);
function canvasSizeInRange(size) {
	return canvasInRange(isString(size) ? Number(toNumString(size)) : size);
}
function zoomLevelInRange(zoom) {
	return round(zoomInRange(zoom), 2);
}
function toMaxWidthCommentFormat(width) {
	return `${maxWidthCommentInRange(isString(width) ? Number(toNumString(width)) : width)}px`;
}
function toZoomFormat(zoomLevel) {
	return `${(zoomLevel * 100).toFixed()}%`;
}
var hasDatabase = arrayHas(DatabaseList);
var hasNameCase = arrayHas(NameCaseList);
var hasBracketType = arrayHas(BracketTypeList);
var hasLanguage = arrayHas(LanguageList);
var hasColumnType = arrayHas(ColumnTypeList);
var hasDatabaseVendor = arrayHas(DatabaseVendorList);
var hasCanvasType = arrayHas(CanvasTypeList);
var hasNameViewMode = arrayHas(NameViewModeList);
function textInRange(width) {
	return Math.max(width, 60);
}
function toSafeString(value) {
	return isString(value) ? value.trim() : "";
}
function isHighLevelTable(zoomLevel) {
	return zoomLevel <= .7;
}
var EDITABLE_SELECTOR = "input, textarea, [contenteditable]";
function isEditableTarget(target) {
	const el = target;
	return Boolean(el && typeof el.closest === "function" && el.closest(EDITABLE_SELECTOR));
}
//#endregion
export { canvasSizeInRange, hasBracketType, hasCanvasType, hasColumnType, hasDatabase, hasDatabaseVendor, hasLanguage, hasNameCase, hasNameViewMode, isEditableTarget, isHighLevelTable, maxWidthCommentInRange, textInRange, toMaxWidthCommentFormat, toNumString, toSafeString, toZoomFormat, zoomInRange, zoomLevelInRange };
